import React from 'react';
import styles from './Header.module.css';

function Header({ userName, onLogout, title, subtitle, icon, extraActions }) {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <img src="/Acciona_neg.png" alt="ACCIONA" className={styles.logo} />
          {!title && (
            <>
              <div className={styles.divider} />
              <span className={styles.subtitle}>{subtitle || 'Artificial Intelligence System for Requirements'}</span>
            </>
          )}
        </div>

        {title && (
          <div className={styles.titleCenter}>
            <div className={styles.titleMain}>
              {icon ?? (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="20" x2="18" y2="10"/>
                  <line x1="12" y1="20" x2="12" y2="4"/>
                  <line x1="6" y1="20" x2="6" y2="14"/>
                  <line x1="2" y1="20" x2="22" y2="20"/>
                </svg>
              )}
              {title}
            </div>
            {subtitle && <div className={styles.titleSub}>{subtitle}</div>}
          </div>
        )}

        <div className={styles.actions}>
          {extraActions}
          <div className={styles.userInfo}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            {userName || 'User'}
          </div>
          <button className={styles.btnLogout} onClick={onLogout} type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            Log Out
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
